<!-- @format -->
<template>
    <div class="gst-manage-booking-cancel">Cancel</div>
</template>

<script>
import LogService from '@core/services/LogService';
import EventFlowMixin from '@tenant/app/mixins/EventFlowMixin';
import prismicConstants from '@tenant/app/utils/constants/prismic';

export default {
    name: 'TheManageBookingCancel',
    mixins: [EventFlowMixin],
    i18nOptions: {
        namespaces: 'main',
        keyPrefix: 'modules.hotel.features.manageBooking',
    },
    testIdOptions: {
        keyPrefix: 'manageBookingCancel',
    },
    async created() {
        try {
            this.content = await this.$prismic.client.getByUID(
                prismicConstants.CUSTOM_TYPES.REPEAT.TENANTS_MMH_CANCEL_FEEDBACK,
                prismicConstants.DOCUMENT_UID.AADVANTAGEHOTELS_MMH_CANCEL_FEEDBACK
            );
        } catch (e) {
            LogService.log(e.message);
        }
    },
};
</script>

<style lang="scss">
@import '@scssMixins';
@import '@scssVariables';
</style>
